<template>
    <div class="markdown" v-elclick="{ selector: 'a', fn: anchorClick }">
        <vue-markdown :anchorAttributes="anchorAttributes" :source="text"></vue-markdown>
    </div>
</template>

<script>
    import VueMarkdown from '@adapttive/vue-markdown';
    import { ElementClick } from '@/directives';
    import { event } from 'vue-gtag';

    export default {
        components: { VueMarkdown },
        directives: {
            elclick: ElementClick
        },
        data: () => ({
            anchorAttributes: {
                target: '_blank'
            }
        }),
        props: {
            text: {
                type: String,
                required: true
            },
            track: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            anchorClick(el) {
                if (this.track) {
                    const href = el.getAttribute('href');
                    event('click', { event_category: 'Markdown Link', event_label: href });
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .markdown {
        white-space: normal;
        ::v-deep {
            p:last-child {
                margin-bottom: 0;
            }
        }
    }
</style>
